import { cn } from '@/lib/utils';
import { hasVisibleFilterItems } from '../index-section-utils';
import {
  IndexSectionBackgroundShell,
  IndexSectionCollectionHeading,
  IndexSectionContainer,
  IndexSectionFilterTabs,
  type IndexSectionViewProps,
  shouldShowCollection,
  shouldShowPinnedCollection,
} from './shared';

export function SplitIndexSectionView({
  layoutProps,
  sectionBackgroundColor,
  filters,
  pinnedCollection,
  collection,
}: IndexSectionViewProps) {
  const canShowFilters = filters.show && hasVisibleFilterItems(filters.items);

  return (
    <IndexSectionBackgroundShell sectionBackgroundColor={sectionBackgroundColor}>
      <IndexSectionContainer layoutProps={layoutProps}>
        <div
          className={cn(
            'grid w-full gap-10',
            canShowFilters && 'lg:grid-cols-[minmax(0,15rem)_minmax(0,1fr)]',
          )}
        >
          {canShowFilters ? (
            <aside className="space-y-8">
              <div className="space-y-3">
                <p className="text-xs font-bold uppercase tracking-widest text-foreground/70">
                  {filters.label}
                </p>
                <IndexSectionFilterTabs
                  showFilters={canShowFilters}
                  filterItems={filters.items}
                  filterKey={filters.key}
                  filterLabel={filters.label}
                  filterLimit={filters.limit}
                  filterBlock={filters.block}
                  mode="vertical"
                />
              </div>
            </aside>
          ) : null}
          <div className="space-y-12">
            {shouldShowPinnedCollection(pinnedCollection) ? pinnedCollection?.body : null}
            {shouldShowCollection(collection) && (
              <section className="space-y-6">
                <IndexSectionCollectionHeading heading={collection.heading} />
                {collection.body}
                {collection.pagination}
              </section>
            )}
          </div>
        </div>
      </IndexSectionContainer>
    </IndexSectionBackgroundShell>
  );
}
